var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classnames from 'classnames';
import Checkbox from './Checkbox';
var CheckboxMenu = React.forwardRef(function (_a, ref) {
    var items = _a.items, onItemChanged = _a.onItemChanged, disabled = _a.disabled, className = _a.className, itemClassName = _a.itemClassName;
    return (_jsx("ul", __assign({ className: classnames('checkbox-list', className), role: "menu", ref: ref }, { children: items &&
            items.map(function (item) { return (_jsx("li", __assign({ className: itemClassName, role: "presentation" }, { children: _jsx(Checkbox, { value: item.selected, text: item.label, disabled: disabled, role: "menuitemcheckbox", extraClass: "", onClick: function (selected) { return onItemChanged(item, selected); } }) }), item.id)); }) })));
});
CheckboxMenu.defaultProps = {
    disabled: false,
    className: undefined,
    itemClassName: undefined,
};
export default CheckboxMenu;
